/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_S3Inputs */

const en_tut_wb_s3 = /** @type {(inputs: Tut_Wb_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect two objects with an arrow to show order or cause and effect.`)
};

const id_tut_wb_s3 = /** @type {(inputs: Tut_Wb_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan dua objek dengan panah untuk menunjukkan urutan atau sebab-akibat.`)
};

/**
* | output |
* | --- |
* | "Connect two objects with an arrow to show order or cause and effect." |
*
* @param {Tut_Wb_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_s3 = /** @type {((inputs?: Tut_Wb_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_s3(inputs)
	return en_tut_wb_s3(inputs)
});